import { fetchProviderByIds } from "../misc";
import { CategoryChartVisibilityFn } from "../categoryChart";

export const doFixedFeeTariffStructureKpisForTheProvidersNotExist: CategoryChartVisibilityFn = async ({
    locationAdminIds
}) => {
    const providers = await fetchProviderByIds(locationAdminIds);

    const hasTariffAtLeastOne =
        providers?.find(d => d.residentialTariffStruct != null && d.residentialTariffStruct !== "blank") != null;

    if (!hasTariffAtLeastOne) return false;

    const fixedProviders = providers?.filter(
        d =>
            d.residentialTariffStruct === "fixed" ||
            d.residentialTariffStruct === "consumptionCharge" ||
            d.residentialTariffStruct === "fixedEntitlementAndExcessConsumptionCharge" ||
            d.residentialTariffStruct === "noChargeToResidents"
    );

    if (fixedProviders?.length === providers?.length) return false;

    return true;
};
